module.exports = __webpack_public_path__ + "img/Fr-T600.b0ab65d5.gif";